
//  DATE PARSER (KEEP SAME)

export const parseMDYDateTime = (s) => {
  if (!s) return null;

  // e.g. "11/10/2025 9:43:45 PM" or "10/11/2025 , 05:53:37 PM"
  const cleaned = s.replace(",", "");
  const [datePart] = cleaned.split(" ");
  const [m, d, y] = (datePart || "").split("/").map((v) => parseInt(v, 10));
  if (!m || !d || !y) return null;

  const timeMatch = cleaned.match(/(\d{1,2}):(\d{2}):(\d{2})/);
  let hh = 0,
    mm = 0,
    ss = 0;
  if (timeMatch) {
    hh = parseInt(timeMatch[1] || "0", 10) || 0;
    mm = parseInt(timeMatch[2] || "0", 10) || 0;
    ss = parseInt(timeMatch[3] || "0", 10) || 0;
  }

  const ampm = cleaned.match(/\b(AM|PM)\b/);
  if (ampm) {
    const mer = ampm[1];
    if (mer === "PM" && hh < 12) hh += 12;
    if (mer === "AM" && hh === 12) hh = 0;
  }

  return new Date(y, m - 1, d, hh, mm, ss);
};

//  TIME ELAPSED (UPDATED)
//  Supports auto-refresh by accepting "now"

export const timeElapsed = (dateStr, now = Date.now()) => {
  const dt = new Date(dateStr);
  if (isNaN(dt)) return "-";

  const diffMs = now - dt.getTime();
  if (diffMs < 0) return "0m";

  const mins = Math.floor(diffMs / (1000 * 60));
  const hrs = Math.floor(mins / 60);
  const days = Math.floor(hrs / 24);

  if (days > 0) return `${days}d ${hrs % 24}h`;
  if (hrs > 0) return `${hrs}h ${mins % 60}m`;
  if (mins <= 0) return "Just now";

  return `${mins}m`;
};

//  SHORT DATE FORMAT

export const formatShortDate = (dateStr) => {
  const dt = new Date(dateStr);
  if (isNaN(dt)) return "-";

  return dt.toLocaleString("en-IN", {
    hour12: true,
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
};

//  YYYY-MM-DD (for inputs)

export const toInputDate = (d) => {
  const pad = (n) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
};
